import React from 'react'

import Link from 'components/Link'
import { QuestionData, StrapiResult } from 'lib/strapi'
import getAvatarURL from '../Idengager/util/getAvatar'

type QuestionsTableProps = {
    questions: Omit<StrapiResult<QuestionData[]>, 'meta'>
    isLoading: boolean
    fetchMore: () => void
    hideLoadMore?: boolean
    className?: string
}

export const QuestionsTable = ({
    questions,
    isLoading,
    fetchMore,
    hideLoadMore,
    className = '',
}: QuestionsTableProps) => {
    return (
        <ul className="m-0 p-0">
            <li className="list-none divide-y divide-dashed divide-gray-accent-light dark:divide-gray-accent-dark">
                {questions.data.length > 0
                    ? questions.data.filter(Boolean).map((question) => {
                          const {
                              attributes: { profile, subject, permalink, body, replies },
                          } = question

                          const numReplies = replies?.data?.length || 0

                          const avatar = getAvatarURL(profile?.data?.attributes)

                          return profile ? (
                              <div key={question.id} className={`grid py-4 sm:gap-2 xl:grid-cols-4 ${className}`}>
                                  <div className="hidden sm:block">
                                      <a
                                          href={`/support/profiles/${profile.data.id}`}
                                          className="group mt-0.5 flex items-center space-x-1 text-sm text-primary"
                                      >
                                          <div className={`h-5 w-5 flex-shrink-0 overflow-hidden rounded-full`}>
                                              {avatar ? (
                                                  <img className="h-full w-full" alt="" src={avatar} />
                                              ) : (
                                                  <svg
                                                      viewBox="0 0 40 40"
                                                      fill="none"
                                                      xmlns="http://www.w3.org/2000/svg"
                                                      className="bg-gray-accent-light"
                                                  >
                                                      <path
                                                          d="M20.0782 41.0392H5.42978C4.03134 41.0392 3.1173 40.1642 3.09386 38.7736C3.07823 37.7814 3.07042 36.797 3.10948 35.8048C3.15636 34.6329 3.72668 33.7345 4.74228 33.1798C8.0782 31.3595 11.4299 29.5783 14.7659 27.7658C15.0081 27.633 15.1565 27.758 15.3362 27.8517C18.1878 29.3439 21.0942 29.4689 24.0626 28.2267C24.1485 28.1955 24.2423 28.1721 24.3126 28.1096C24.9298 27.5861 25.4845 27.7971 26.1251 28.1486C29.1173 29.7971 32.1331 31.4143 35.1487 33.0238C36.4534 33.7191 37.094 34.766 37.0706 36.2426C37.0549 37.0785 37.0706 37.9067 37.0706 38.7426C37.0628 40.1254 36.1409 41.0395 34.7659 41.0395H20.0783L20.0782 41.0392Z"
                                                          fill="#BFBFBC"
                                                      ></path>
                                                      <path
                                                          d="M19.8359 27.0625C17.0859 26.9687 14.8047 25.6094 13.1251 23.1953C10.3751 19.2344 10.7032 13.6093 13.8516 10.0001C17.2735 6.08599 22.9452 6.10943 26.336 10.0469C29.9376 14.2345 29.711 20.8437 25.8126 24.6405C24.2188 26.1952 22.3126 27.0312 19.8362 27.0624L19.8359 27.0625Z"
                                                          fill="#BFBFBC"
                                                      ></path>
                                                  </svg>
                                              )}
                                          </div>
                                          <span className="font-medium text-primary opacity-60 line-clamp-1 group-hover:opacity-100 dark:text-primary-dark">
                                              {profile.data.attributes.firstName} {profile.data.attributes.lastName}
                                          </span>
                                      </a>
                                  </div>
                                  <div className="sm:col-span-3">
                                      <Link
                                          to={`/questions/${permalink}`}
                                          className="block whitespace-normal font-bold leading-snug"
                                      >
                                          {subject}
                                      </Link>
                                      <a
                                          href={`/support/profiles/${profile.data.id}`}
                                          className="group mt-0.5 flex items-center space-x-1 text-sm text-primary sm:hidden"
                                      >
                                          <div className={`h-5 w-5 flex-shrink-0 overflow-hidden rounded-full`}>
                                              {/*profile.avatar ? (
                                                  <img className="w-full h-full" alt="" src={question.profile.avatar} />
                                              ) : (
                                                  <svg
                                                      viewBox="0 0 40 40"
                                                      fill="none"
                                                      xmlns="http://www.w3.org/2000/svg"
                                                      className="bg-gray-accent-light"
                                                  >
                                                      <path
                                                          d="M20.0782 41.0392H5.42978C4.03134 41.0392 3.1173 40.1642 3.09386 38.7736C3.07823 37.7814 3.07042 36.797 3.10948 35.8048C3.15636 34.6329 3.72668 33.7345 4.74228 33.1798C8.0782 31.3595 11.4299 29.5783 14.7659 27.7658C15.0081 27.633 15.1565 27.758 15.3362 27.8517C18.1878 29.3439 21.0942 29.4689 24.0626 28.2267C24.1485 28.1955 24.2423 28.1721 24.3126 28.1096C24.9298 27.5861 25.4845 27.7971 26.1251 28.1486C29.1173 29.7971 32.1331 31.4143 35.1487 33.0238C36.4534 33.7191 37.094 34.766 37.0706 36.2426C37.0549 37.0785 37.0706 37.9067 37.0706 38.7426C37.0628 40.1254 36.1409 41.0395 34.7659 41.0395H20.0783L20.0782 41.0392Z"
                                                          fill="#BFBFBC"
                                                      ></path>
                                                      <path
                                                          d="M19.8359 27.0625C17.0859 26.9687 14.8047 25.6094 13.1251 23.1953C10.3751 19.2344 10.7032 13.6093 13.8516 10.0001C17.2735 6.08599 22.9452 6.10943 26.336 10.0469C29.9376 14.2345 29.711 20.8437 25.8126 24.6405C24.2188 26.1952 22.3126 27.0312 19.8362 27.0624L19.8359 27.0625Z"
                                                          fill="#BFBFBC"
                                                      ></path>
                                                  </svg>
                                              )}*/}
                                          </div>
                                          <div className="my-1 font-medium text-primary opacity-60 line-clamp-1 group-hover:opacity-100 dark:text-primary-dark">
                                              {profile.data.attributes.firstName} {profile.data.attributes.lastName}
                                          </div>
                                      </a>
                                      {/*
                                            Last activity:
                                            <span className="whitespace-nowrap p-4 text-sm font-semibold">
                                                {dayFormat(dateToDays(latestReply.created_at))}
                                            </span>
                                        */}
                                      {/*{question.topics.map(({ topic }: { topic: { id: string; label: string } }) => {
                                          return (
                                              <Link
                                                  key={topic.id}
                                                  to={`/questions/topics/${slugify(topic.label, {
                                                      lower: true,
                                                  })}`}
                                                  className="bg-gray-accent-light rounded-sm"
                                              >
                                                  {topic.label}
                                              </Link>
                                          )
                                      })}*/}
                                      <p className="m-0 mt-1 whitespace-normal break-words text-sm line-clamp-2">
                                          {body}
                                      </p>
                                      <Link
                                          to={`/questions/${permalink}`}
                                          className="whitespace-nowrap text-sm font-semibold"
                                      >
                                          {numReplies} {numReplies === 1 ? 'reply' : 'replies'}
                                      </Link>
                                  </div>
                              </div>
                          ) : null
                      })
                    : new Array(10).fill(0).map((_, i) => (
                          <li key={i} className="">
                              <div className="text-gray-900 space-y-2 whitespace-nowrap py-4 pl-4 pr-4 text-sm font-medium">
                                  <div className="h-4 w-96 w-3/4 animate-pulse rounded-sm bg-gray-accent-light dark:bg-gray-accent-dark"></div>
                                  <div className="h-4 w-60 w-3/4 animate-pulse rounded-sm bg-gray-accent-light dark:bg-gray-accent-dark"></div>
                                  <div className="h-4 w-36 w-3/4 animate-pulse rounded-sm bg-gray-accent-light dark:bg-gray-accent-dark"></div>
                              </div>

                              <div className="text-gray-500 animate-pulse whitespace-nowrap py-4 pl-4 pr-4 text-sm font-semibold">
                                  <div className="h-4 w-3/4 animate-pulse rounded-sm bg-gray-accent-light dark:bg-gray-accent-dark"></div>
                              </div>
                              <div className="text-gray-500 animate-pulse whitespace-nowrap p-4 text-sm font-semibold text-gray">
                                  <div className="h-4 w-3/4 animate-pulse rounded-sm bg-gray-accent-light dark:bg-gray-accent-dark"></div>
                              </div>
                          </li>
                      ))}
            </li>

            {!hideLoadMore && (
                <li className="list-none py-2">
                    <button
                        className="relative block w-full rounded bg-gray-accent-light p-3 text-[15px] font-bold text-primary/75 hover:bg-gray-accent-light hover:text-red active:top-[0.5px] active:scale-[.99] dark:bg-gray-accent-dark dark:text-primary-dark/75"
                        onClick={fetchMore}
                        disabled={isLoading}
                    >
                        Load more
                    </button>
                </li>
            )}
        </ul>
    )
}

export default QuestionsTable
